import React from 'react';
import ContentLoader from 'react-content-loader';

interface Props {
  width: number | string;
  height: number | string;
  speed?: number;
  borderY?: number;
  borderX?: number;
  backgroundColor?: string;
  foregroundColor?: string;
  className?: string;
}

export const CustomSkeleton: React.FC<Props> = ({
  width,
  height,
  borderY = 4,
  borderX = 4,
  backgroundColor = '#ebebeb',
  foregroundColor = '#f5f5f5',
  speed,
  className,
}) => {
  return (
    <div className={className} data-testid={'imagery-custom-skeleton'}>
      <ContentLoader
        speed={speed ?? 1}
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        backgroundColor={backgroundColor}
        foregroundColor={foregroundColor}
      >
        <rect x="0" y="0" rx={borderX} ry={borderY} width={width} height={height} />
      </ContentLoader>
    </div>
  );
};

export default CustomSkeleton;
